module.exports = __webpack_public_path__ + "img/tema-1-15.96a75caf.png";